<template>
  <div>
    <el-form 
      :model="info" 
      :rules="rules" 
      ref="form" 
      label-width="110px"
    >
      <el-form-item label="姓名" prop="nomRte">
        <el-autocomplete
          v-model.number="info.nomRte"
          :fetch-suggestions="getAddress"
          placeholder="可检索"
          style="width: 100%"
          @select="handleAddress"
          clearable
        >
          <template slot-scope="{ item }">
            <div style="padding:10px 0">
              <div style="line-height: 20px; text-overflow: ellipsis;overflow: hidden;">
                {{ item.nomRte }} {{ item.telefRte }}
              </div>
              <div style="line-height: 20px; text-overflow: ellipsis;overflow: hidden; color:#b4b4b4; font-size:12px;">
                {{ item.pobRte }} {{ item.dirRte }}
              </div>
            </div>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="电话" prop="telefRte">
        <el-input v-model="info.telefRte" clearable></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="dirRte">
        <el-autocomplete
          v-model.number="info.dirRte"
          :fetch-suggestions="getGoogleAddress"
          placeholder="可检索"
          style="width: 100%"
          @select="handleGoogleAddress"
          clearable
        >
          <template slot-scope="{ item }">
            <div style="padding:10px 0">
              <div style="line-height: 20px; text-overflow: ellipsis;overflow: hidden;">
                {{ item.address }}
              </div>
              <div style="line-height: 20px; text-overflow: ellipsis;overflow: hidden; color:#b4b4b4; font-size:12px;">
                {{ item.info }}
              </div>
            </div>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Localidad" prop="pobRte">
            <el-input v-model="info.pobRte" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮编" prop="codPosNacRte">
            <el-input v-model="info.codPosNacRte" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { address } from '../api/api';
import { googleAutoComplete, googleDetails } from '../google';

export default {
  name: 'HomeFa',
  data() {
    return {
      info: {
        nomRte: '',
        telefRte: '',
        pobRte: '',
        dirRte: '',
        codPosNacRte: ''
      },

      rules: {
        nomRte: [ { required: true, message: '请填写发件人姓名', trigger: 'change' } ],
        telefRte: [ { required: true, message: '请填写发件人电话', trigger: 'change' } ],
        pobRte: [ { required: true, message: '请填写发件人城市', trigger: 'change' } ],
        dirRte: [ { required: true, message: '请填写发件人地址', trigger: 'change' } ],
        codPosNacRte: [ { required: true, message: '请填写发件人邮编', trigger: 'change' } ]
      }
    }
  },
  created () {
    // 获取最近一次发件人
    this.getAddress('', (data) => {
      // 默认填写
      if(data.length > 0) {
        this.handleAddress(data[0])
      }
    })
  },
  methods: {
    getAddress(value, cb) {
      address(value, 0).then(res => {
        cb(res)
      })
    },
    handleAddress(addres) {
      // 获取规则的keys
      Object.keys(this.info).map((item) => {
        this.info[item] = addres[item]  
      })
    },
    getGoogleAddress(value, cb) {
      googleAutoComplete(value, res => {
        cb(res)
      })
    },
    handleGoogleAddress(addres) {
      googleDetails(addres.id, res => {
        this.info.dirRte = addres.address

        if(res.code) {
          this.info.codPosNacRte = res.code
        }
        if(res.city) {
          this.info.pobRte = res.city
        }
      })
    },
    // 设置
    set(data) {
      this.info = {
        nomRte: data.name,
        telefRte: data.tel,
        pobRte: data.pob,
        dirRte: data.dir,
        codPosNacRte: data.cod
      }
    },
    // 清空
    empty() {
      this.set({
        name: '',
        tel: '',
        pob: '',
        dir: '',
        cod: ''
      }, false)
    },
    async get() {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            resolve(this.info) 
          } else {
            reject(false)
          }
        });
      });
    }
  },
}
</script>